import React from 'react';
import PropTypes from 'prop-types';

const getGeoFormat = (numberLabel) => (
  numberLabel.toString().length < 2 ? 'circle' : 'semi-circle'
);

const iconStyle = (iconUrl) => ({
  background: `var(${iconUrl})`
});

function IconWithNumber({
  numberLabel, iconUrl, style, title
}) {
  return (
    <div className="icon-with-number" style={style}>
      <span className={getGeoFormat(numberLabel)}>
        {numberLabel}
        <i style={iconStyle(iconUrl)} title={title} />
      </span>
    </div>
  );
}

IconWithNumber.propTypes = {
  numberLabel: PropTypes.number.isRequired,
  iconUrl: PropTypes.string.isRequired,
  style: PropTypes.object,
  title: PropTypes.string.isRequired
};

IconWithNumber.defaultProps = {
  style: {}
};

export default IconWithNumber;
